import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { AdminDashboardRecentActivities, AdminDashboardSectionState } from "@/types/dashboard";

export type DashboardRecentActivitiesState = AdminDashboardSectionState<AdminDashboardRecentActivities>;

export const dashboardRecentActivitiesInitialState: DashboardRecentActivitiesState = {
  data: null,
  error: null,
};

const slice = createSlice({
  name: "dashboardRecentActivities",
  initialState: dashboardRecentActivitiesInitialState,
  reducers: {
    setDashboardRecentActivitiesAction(state, { payload }: PayloadAction<AdminDashboardRecentActivities | null>) {
      state.data = payload;
      state.error = null;
    },
    setDashboardRecentActivitiesErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload;
    },
  },
});

export const { setDashboardRecentActivitiesAction, setDashboardRecentActivitiesErrorAction } = slice.actions;
export default slice.reducer;
